export default "/images/a3e665ec41d937472462067a580f26ce.avif";